import React from 'react'

import { ChipSwitch, ChipSwitchButton } from '../../components/ChipSwitch'
import { useFinancialsTableContext } from '../../components/financials-table'
import { EarningsEstimateType } from '../earnings-common/types'
import { EarningsSettings } from './types'

type Props = {
  label?: string
}

export function EstimateTypeChipSwitch({ label }: Props) {
  const { settings, setSettings } = useFinancialsTableContext<EarningsSettings>()

  const toggleSetting = (key: keyof EarningsSettings, value: EarningsSettings[keyof EarningsSettings]) => {
    setSettings({
      ...settings,
      [key]: value,
    })
  }

  const estimateType = settings.estimateType

  return (
    <ChipSwitch size="small" label={label || ''}>
      <ChipSwitchButton
        active={estimateType === EarningsEstimateType.eps}
        onClick={() => toggleSetting('estimateType', EarningsEstimateType.eps)}
      >
        EPS
      </ChipSwitchButton>
      <ChipSwitchButton
        active={estimateType === EarningsEstimateType.epsGaap}
        onClick={() => toggleSetting('estimateType', EarningsEstimateType.epsGaap)}
      >
        GAAP EPS
      </ChipSwitchButton>
      <ChipSwitchButton
        active={estimateType === EarningsEstimateType.sales}
        onClick={() => toggleSetting('estimateType', EarningsEstimateType.sales)}
      >
        Sales
      </ChipSwitchButton>
    </ChipSwitch>
  )
}
